import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import formatRupiah from "utils/formatRupiah";
import { getNamaBulan } from "utils/namaBulan";

const DetailPenggajianModal = ({ dataDetail, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Detail Gaji</DialogTitle>
      <DialogContent>
        <Typography>
          Rincian Gaji Periode: {getNamaBulan(dataDetail?.bulan)} -{" "}
          {dataDetail?.tahun}
        </Typography>
        <Typography>
          Nama Karyawan: {dataDetail?.id_karyawan} - {dataDetail?.nama_karyawan}
        </Typography>
        <hr />
        <br />
        <Typography>Rincian Kerja</Typography>
        <hr />
        <Typography>Hari Kerja: {dataDetail?.jumlah_hadir} Hari</Typography>
        <Typography>Total Telat: {dataDetail?.total_telat} Menit</Typography>
        <br />
        <Typography>Rincian Gaji</Typography>
        <hr />
        <Typography>
          Gaji Pokok:{" "}
          {dataDetail?.gaji_pokok &&
            formatRupiah(parseFloat(dataDetail.gaji_pokok))}
        </Typography>
        <Typography>
          Lembur:{" "}
          {dataDetail?.lembur && formatRupiah(parseFloat(dataDetail.lembur))}
        </Typography>
        <Typography>
          Rajin:{" "}
          {dataDetail?.rajin && formatRupiah(parseFloat(dataDetail.rajin))}
        </Typography>
        <Typography>
          Transport:{" "}
          {dataDetail?.transportasi &&
            formatRupiah(parseFloat(dataDetail.transportasi))}
        </Typography>
        <Typography>
          Pulsa:{" "}
          {dataDetail?.pulsa && formatRupiah(parseFloat(dataDetail.pulsa))}
        </Typography>
        <Typography>
          Tunai Jabatan:{" "}
          {dataDetail?.tunjangan_jabatan &&
            formatRupiah(parseFloat(dataDetail.tunjangan_jabatan))}
        </Typography>
        <Typography>
          Uang Makan:{" "}
          {dataDetail?.uang_makan &&
            formatRupiah(parseFloat(dataDetail.uang_makan))}
        </Typography>
        <br />
        <Typography>
          Potongan NBH:{" "}
          {dataDetail?.potongan_nbh &&
            formatRupiah(parseFloat(dataDetail.potongan_nbh))}
        </Typography>
        <Typography>
          NBH Bulan Ini:{" "}
          {dataDetail?.nbh_bln_ini &&
            formatRupiah(parseFloat(dataDetail.nbh_bln_ini))}
        </Typography>{" "}
        <Typography>
          Sisa NBH Bulan Lalu:{" "}
          {dataDetail?.sisa_nbh_bln_ini &&
            formatRupiah(parseFloat(dataDetail.sisa_nbh_bln_ini))}
        </Typography>
        <Typography>
          Sisa NBH{" "}
          {dataDetail?.sisa_nbh &&
            formatRupiah(parseFloat(dataDetail.sisa_nbh))}
        </Typography>
        <br />
        <Typography>
          Potongan Tabungan:{" "}
          {dataDetail?.potongan_tabungan &&
            formatRupiah(parseFloat(dataDetail.potongan_tabungan))}
        </Typography>
        <Typography>
          Potongan Pinjaman:{" "}
          {dataDetail?.potongan_pinjaman &&
            formatRupiah(parseFloat(dataDetail.potongan_pinjaman))}
        </Typography>
        <br />
        <Typography>
          Total Gaji:{" "}
          {dataDetail?.total_gaji &&
            formatRupiah(parseFloat(dataDetail.total_gaji))}
        </Typography>
        <hr />
      </DialogContent>
      <DialogActions>
        <Button
          type="submit"
          variant="contained"
          color="inherit"
          sx={{
            fontSize: "14px",
            fontWeight: "bold",
            padding: "10px 20px",
          }}
          onClick={onClose}
        >
          Tutup
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetailPenggajianModal;
